"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationKeys = exports.defaultMessageTranslations = exports.ShowErrorNotificationEvent = exports.Name = void 0;
const Name = exports.Name = 'show-error-notification';
const ShowErrorNotificationEvent = exports.ShowErrorNotificationEvent = Name;

/**
 * Place the default error message translations into this object.
 * We are using keys to identify the message in code, not the default
 * EN translations. The default EN translation text should match
 * the deafult translation in Online dictionary. Although these
 * EN text values here will be most likely used only while testing,
 * they are also displayed as a fallback when the translation will
 * be missing on production environment.
 */
const defaultMessageTranslations = exports.defaultMessageTranslations = {
  genericError: 'Sorry, something went wrong!',
  selectedQuantityIsNotAvailable: 'Selected quantity is not available due to stock limitations.',
  offerIsNotAvailable: 'Offer is not available at the moment.'
};
/**
 * Use this object to access the particular message ID / key.
 */
const translationKeys = exports.translationKeys = Object.fromEntries(Object.keys(defaultMessageTranslations).map(cur => [cur, cur]));

/**
 * Options for the notification popup.
 */
//# sourceMappingURL=index.js.map